export enum IntervalEnum {
  "HALF_YEAR" = 6,
  "ONE_YEAR" = 12,
  "THREE_YEARS" = 36
}